import { baseEntity } from 'mocks/server/data/generation/generateBaseEntity';
import { formatSize, linkedAssetFrame } from 'mocks/server/data/generation/generateDetails';
import { ILiveLinkedAsset } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { LiveStatus } from 'utils/statuses';

const BASE_LINKED_ASSET_ID = '2000000000';

export const baseLinkedAsset = (): ILiveLinkedAsset => {
  const generatedBaseEntity = baseEntity(EntityType.LINKED_ASSET, BASE_LINKED_ASSET_ID);
  const name = generatedBaseEntity.name ?? '';
  return {
    ...generatedBaseEntity,
    formatSize: formatSize(),
    status: LiveStatus.ACTIVE,
    hasDraft: false,
    linkedAssetFrames: [
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
    ],
  };
};

export const linkedAssetThatFailsToDeactivate: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToDeactivateLA',
  name: 'failToDeactivateLA',
  status: LiveStatus.ACTIVE,
};

export const linkedAssetThatFailsToDeactivateNoDraft: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToDeactivateLANoDraft',
  name: 'failToDeactivateLANoDraft',
  status: LiveStatus.ACTIVE,
};

export const linkedAssetThatFailsToArchive: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToArchiveLA',
  name: 'failToArchiveLA',
  status: LiveStatus.INACTIVE,
};

export const linkedAssetThatFailsToArchiveNoDraft: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToArchiveLANoDraft',
  name: 'failToArchiveLANoDraft',
  status: LiveStatus.INACTIVE,
};

export const linkedAssetThatFailsToActivate: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToActivateLA',
  name: 'failToActivateLA',
  status: LiveStatus.INACTIVE,
};

export const linkedAssetThatFailsToActivateNoDraft: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToActivateLANoDraft',
  name: 'failToActivateLANoDraft',
  status: LiveStatus.INACTIVE,
};

export const linkedAssetThatFailsToUnarchive: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToUnarchiveLA',
  name: 'failToUnarchiveLA',
  status: LiveStatus.ARCHIVED,
};

export const linkedAssetThatFailsToUnarchiveNoDraft: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'failToUnarchiveLANoDraft',
  name: 'failToUnarchiveLANoDraft',
  status: LiveStatus.ARCHIVED,
};

export const inactiveLinkedAsset: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'inactiveLA',
  status: LiveStatus.INACTIVE,
};

export const archivedLinkedAsset: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'archivedLA',
  status: LiveStatus.ARCHIVED,
};

export const linkedAssetWithLongName = (): ILiveLinkedAsset => {
  const generatedBaseEntity = baseEntity(EntityType.LINKED_ASSET);
  const name = generatedBaseEntity.name ?? '';
  return {
    ...generatedBaseEntity,
    spaceId: '2222222222',
    name: 'This is a very long name to show an example of how the app deals with really long names',
    mediaOwnerName: 'All City Media Solutions',
    environment: 'MotorwayServiceStation',
    formatSize: formatSize(),
    status: LiveStatus.INACTIVE,
    hasDraft: false,
    linkedAssetFrames: [
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
      linkedAssetFrame(name),
    ],
  };
};

export const linkedAssetWithDraft: ILiveLinkedAsset = {
  ...baseLinkedAsset(),
  spaceId: 'LAWithDraft',
  status: LiveStatus.ACTIVE,
  hasDraft: true,
};

export const linkedAssets: ILiveLinkedAsset[] = [
  linkedAssetThatFailsToDeactivate,
  linkedAssetThatFailsToDeactivateNoDraft,
  linkedAssetThatFailsToArchive,
  linkedAssetThatFailsToArchiveNoDraft,
  linkedAssetThatFailsToActivate,
  linkedAssetThatFailsToActivateNoDraft,
  linkedAssetThatFailsToUnarchive,
  linkedAssetThatFailsToUnarchiveNoDraft,
  inactiveLinkedAsset,
  archivedLinkedAsset,
  linkedAssetWithDraft,
  linkedAssetWithLongName(),
  baseLinkedAsset(),
];
